export default {
  en: {
    auth: {
      forms: {
        labels: {
          firstName: 'First name',
          lastName: 'Last name',
          username: "User name",
          email: 'Email',
          phone: 'Enter a Phone Number',
          accountType: 'Account Type',
          password: 'Password',
          confirmPassword: 'Confirm Password',
          agreeTerms: 'I agree with Terms and use of Guio',
          signup: 'Sign Up',
          cancel: 'Cancel',
          submit: 'Submit',
          forgotPassword: "Forgot Password",
          rememberMe: "Remember Me",
          logIn: "Log In",
          logInWithGoogle: "Log in With Google",
          search: "Search"
        },
        errors: {
          firstName: 'First name is required',
          lastName: 'Last name is required',
          username: "User Name is required",
          emailMustBeValid: 'Must be valid e-mail',
          emailRequired: 'E-mail is required',
          phone: 'Phone number is invalid',
          accountType: 'Please select an account type',
          passwordRequired: 'password is required',
          passwordLength: 'password should at least 6 characters',
          confirmPasswordRequired: 'Password confirmation is required',
          confirmPasswordMatch: 'Passwords must match',
          phoneRequired: "Phone number is required",
          phoneMinLength: "Phone number should be atleast 7 digits",
          phoneMaxLength: "Phone number should be atmost 15 digits",
          invalidNumber: "Only digits allowed"
        },
        validations:{
          invalidEmail: "Invalid Email",
          emailRequired: "Email is required",
          passwordRequired: "Password is required",
          selectAccountType: "Please Select Account Type"
        },

      },
      login: {
        welcome: "Welcome Back!",
        pleaseLogin: "Please Login to your account.",
        firstTimeUser: "First Time User",
        forgotPassword: "Forgot Password",
        rememberMe: "Remember Me",
      },
      signup: {
        signupSuccessMessage: 'Account created successfully',
        sinupErrorMessage: '',
        pleaseComplete: 'Please complete to create your account',
        or: 'Or',
        signUpWithGoogle: 'Sign Up with Google',
        haveAnAccount: 'Already have an account? Signin',
        termsOfUse: 'Term of use Privacy policy',
        completeAccountTypeSetUp: 'Complete Account Set Up,',
        byChoosingAccountType: 'By choosing account type',
        accountTypes: {
          mentor: 'Mentor',
          parent: 'Parent',
          mentee: 'Mentee'
        }
      },
      passwordReset: {
        passwordResetButton: "Send Request",
        passwordResetDescription: "Enter your email and we send you a pasword reset link",
        checkEmail: 'Please check your email and click on the provided link to reset your password.'
      }
    },
    dashboard:{
      nav: {
        dropDownMenu: {
          dashboard: "Dashboard",
          dayMode: "Day Mode",
          nightMode: "Night Mode",
          logOut: "Log Out"
        },
        sideNavigationItems: {
          home: 'Home',
          account: 'Account',
          profile: 'Profile',
          chat: 'Chat',
          sharedWithMe: 'Shared with me',
          kids: "Kids",
          mentors: "Mentors",
          assessment: "Assessment",
          starred: 'Starred',
          forums: {
            forums: 'Forums',
            home: 'Home',
            exploreTopics: 'Explorer Topics',
            myTopics: 'My Topics',
            myAnswers: 'My Answers'
          }
        }
      },
      home: {
        message: 'Home Dashboard',
      },
      calendar: {
        today: "Today",
        day: "Day",
        week: "Week",
        month: "Month",
        fourDays: "4 days",
        close: "Close",
        view: "View",
        createdBy: "Created By",
        date: "Date",
        duration: "Duration",
        description: "Description",
        type: "Type",
        nature: "Nature",
        link: "Link",
        participants: "Participants",
        minutes: "Minutes",
        none: "None",
        public: "Public",
        closed: "Closed",
        video: "Video",
        notVideo: "Not Video"
      },
      kids: {
        noKidsCreated: "You've not added a kid yet.",
        title: {
          myKids: "My Kids",
        },
        added: "Added",
        buttons: {
          back: "Back",
          cancel: "Cancel",
          continue: "Continue",
          addNew: "Add New",
          edit: "Edit",
          delete: 'Delete'
        },
        stepForm: {
          personalInformation: "Personal Information",
          security: "Security"
        }
      },
      assessments: {
        buttons: {
          submit: "Submit",
          next: "Next",
          begin: "Begin",
          continue: "Agree and Continue",
          exit: "Exit",
          finish: "Finish"
        },
        completed: "Completed",
        submitedModal: {
          title: "Assessment Completed",
          body: "Guiomentor congradulates you on finishing your {assessmentTitle} assessment"
        },
        table: {
          headers: {
            name: "Name",
            level: "Level",
            numberOfQuestions: "Number of questions",
            time: "Time",
            category: "Category",
            take: "Take"
          },
          loadingText: "Loading... Please wait",
          noDataText: "No Assessments Available",
          assessmentsPerPage: "assessments per page"
        },
        instructions: {
          title: "Before you start the assessment, you should agree to following terms.",
          terms: {
            answering: "The questions of this assessment are in multi-choice format, chose your best option.",
            nextAction: "To submit a question answered, click the next button and the finish button if it was the last question.",
            noGoingBack: "Once a question answered and submited can not be edited.",
            timer: "The timer shows the time the assement will take, and counts down as the process of answering goes on.",
            finishAssessment: "All questions should be answered, so as to label this assessment as complete.",
          },
          noAgreement: "You did not agree to the assessment's instruction."
        },
        assessmentBackDialog:{
          confirm: "Confirm Action",
          backMessage: "Are sure you want to go Back?, You Assesment will be ended",
          cancel: "Cancel",
          back: "Back"
        },
        timer: {
          seconds: "Seconds",
          minutes: "Minutes",
          hours: "Hours"
        },
        timeUpDialog: {
          timeUp:"Time is Up!",
          timeUpMessage:"Your session has ended"
        }
      },
      logOutDialog:{
        logOutConfirm: "Confirm Log Out",
        logOutMessage: "Are sure you want to Log Out?",
        cancel: "Cancel",
        logOut: "Log Out"       
      },
      mentors:{
        book: "Book Session",
        appointmentCard:{
          title:"Book Appointment",
          date:"Date of Appointment",
          duration: "Duration (minutes)",
          time:"Choose Time",
          description: "Descricption",
          cancel:"Cancel",
          confirm: "Confirm",
          successMessage:"Appointment has been set with your mentor",
          errors:{
            durationNotNegative: "Duration can not be a negative",
            durationRequired: "Duration is Required",
            descriptionLimit: "Description should not exceed 500 characters",
            descriptionRequired: "Description is required",
            dateRequired: "Date is required",
            meetingTime: "Meeting time is required"
          }
        }
      }
    },
    profile: {
      nav: {
        profile: 'Profile',
        notifications: 'Notification',
        favorites: 'Favorites',
        passwordAndSecurity: 'Password & Security'
      },
      edit: {
        title: 'Edit Profile',
        deleteMyAccount: 'Delete this account',
        hello: 'Hello',
        byDeleting: 'By deleting this account, all user data, related chats, posts and all answers will be erased.',
        deleteConfirmation: 'Are you sure you want to delete this account?',
        deleteSuccess: 'Profile deleted successfully',
        updatedSuccess: 'Your profile was updated',
        forms: {
          labels: {
            userName: 'Username',
            dateOfBirth: 'Date of birth',
            country: 'Country',
            save: 'Save Changes',
            deleteAccount: 'Delete Account',
            delete: 'Delete'
          },
          errors: {
            dateOfBirth: 'Birthday is required',
            country: 'Country is required'
          }
        },
        fileUploadError: "We couldn't upload your avatar. Please try again",
        fileSizeLimit: "Image too big.Please select a file less than 1MB."
      },
      passwordChange: {
        labels: {
          passwordChangeTitle: "Change Password",
          currentPassword: "Current Password",
          newPassword: "New Password",
          confirmPassword: "Confirm Password",
          passwordChangeButton: "Change Password"
        },
        changePasswordAlert: "Password changed successfully. This will take effect on your next login.",
        errors: {
          currentPasswordRequired: "Current Password is required",
          currentPasswordCharacters: "Current Password must be at least 6 characters long",
          newPasswordRequired: "New Password is required",
          newpasswordCharacters: "New Password must be at least 6 characters long",
          passwordConfirmation: "Password confirmation is required",
          passwordMatch: "Passwords must match",
          ChangeNotSuccessfull: "Password change unsuccessful"
        }
      }
    },
    passwordChange:{
      labels:{
      passwordChangeTitle: "Change Password",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      passwordChangeButton: "Change Password",
      },
      passwordChangeAlert: "Password changed successfully. This will take effect on your next login",
      errors: {
        currentPasswordRequired: "Current Password is required",
        currentPasswordCharacters: "Current Password must be at least 6 characters long",
        newPasswordRequired: "New Password is required",
        newpasswordCharacters: "New Password must be at least 6 characters long",
        passwordConfirmation: "Password confirmation is required",
        passwordMatch: "Passwords must match"
      }
    },
    snackbar: {
      close: "Close"
    },
    notFound: {
      pageNotFound: "Page not found",
      oops: "Oops... Something went wrong",
      pageUnavailable: "The page you are looking for might have been removed or its temporary unavailable",
      goBack: "Go Back...",
      serverError: "Something went wrong on the server"
    },
    errors: {
      somethingWentWrongError: 'Something went wrong',
      weCouldNotGetProfile: "We couldnot get ur profile. Please reload window to try again",
      emailTaken: "Email {email} is already taken.",
      usernameTaken: "Username {username} is already taken.",
      emailAndUsernameTaken: "Email {email} and Username {username} are already taken.",
      noPermissions: ":( Sorry you donot have the permissions to access this page."
    },
    internetBanner:{
      onlineMessage:"Back Online",
      offlineMessage:"No Internet Connection"
    },
    events: {
      eventInformation: "Event Information",
      participants: "Participants",
      eventName: "Event Name",
      duration: "Duration",
      minutes: "Minutes",
      numberOfParticipants: "Number of participants",
      publicEvent: "Public Event",
      eventLink: "Event Link",
      date: "Date",
      time: "Time",
      confirmDelete:{
        confirm:"Are you sure you want to delete this event",
        title:"Delete This Event?",
        delete:"Delete",
        cancel: "cancel"
      },
      editCard:{
        title:"Edit Event",
        date:"Date of Appointment",
        duration: "Duration (minutes)",
        time:"Choose Time",
        description: "Descricption",
        cancel:"Cancel",
        save: "Save",
        successMessage:"Event edited successfully",
        errors:{
          durationLimit: "Duration should be atleast 15",
          durationRequired: "Duration is Required",
          descriptionLimit: "Description should not exceed 500 characters",
          descriptionRequired: "Description is required",
          dateRequired: "Date is required",
          timeRequired: "Time is required",
        }
      },
      success: {
        deleteEvent: "Event deleted successfuly"
      }
    }
  }
}
